/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Search_CarrierInputs */

const en_orders_search_carrier = /** @type {(inputs: Orders_Search_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search carrier...`)
};

const es_orders_search_carrier = /** @type {(inputs: Orders_Search_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar transportista...`)
};

/**
* | output |
* | --- |
* | "Search carrier..." |
*
* @param {Orders_Search_CarrierInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_search_carrier = /** @type {((inputs?: Orders_Search_CarrierInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Search_CarrierInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_search_carrier(inputs)
	return es_orders_search_carrier(inputs)
});